$(document).ready(function() {
    $(document).on('click', '.calendar_body .day', function() {
        var selectedDay = $(this).attr('data-day');

        $('.day_events').hide();

        $('.day_events').filter('[data-selected-day="' + selectedDay + '"]').fadeIn(300);

        $('.calendar_body .day').removeClass('selected');
        $(this).addClass('selected');
    });
});